import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, mapTo, switchMap, tap } from 'rxjs/operators';
import { AccountsContextService } from '../accounts/account-context.service';
import { AccountsService } from '../accounts/accounts.service';

@Injectable({
  providedIn: 'root'
})
export class IndexPageGuard {
  constructor(
    private ctxService: AccountsContextService,
    private router: Router,
    private accountsService: AccountsService,
  ) {}

  public canActivate(): Promise<boolean>|Observable<boolean> {
    const storedAccountInfo = this.ctxService.storedAccountInfo;

    if (storedAccountInfo) {
      return this.router
        .navigateByUrl(
          this.ctxService.getAccountDashboardRoute({
            id: storedAccountInfo.id,
            accountType: storedAccountInfo.type
          })
        )
        .finally(() => false);
    } else {
      return this.ctxService.multipleAccountContext$
        .pipe(
          switchMap(
            hasMultipleAccounts => hasMultipleAccounts
              ? of(this.ctxService.ACCOUNTS_LIST_URL)
              : this.accountsService.accounts$
                .pipe(
                  map(([pubList, advList]) => {
                    const [firstAccount] = [...pubList, ...advList];
                    return firstAccount
                      ? this.ctxService.getAccountDashboardRoute(firstAccount)
                      : `${this.ctxService.ACCOUNTS_WIZARD_URL}/advertiser`;
                  }),
                )
          ),
          tap(redirectUrl => this.router.navigate([redirectUrl])),
          mapTo(false),
        );
    }
  }
}
